import { useState, useEffect } from 'react';

import style from './index.module.scss';

export default function ToastNotification({ text, type = 'success', fadeOutTime = 2000, removeToast }) {
	const [hide, setHide] = useState(false);
	let removeToastFadeout = false;
	let removeToastTimeout = false;

	/**
	 * On load, Start fadeout timer.
	 */
	useEffect(() => {
		removeToastTimer();
	}, []);

	/**
	 * If a timeout is set, then start
	 * couting down to removal of this component.
	 */
	const removeToastTimer = () => {
		if (false !== fadeOutTime) {
			removeToastFadeout = setTimeout(() => {
				// Runs fadeout animation.
				setHide(true);

				// Tell the parent component to remove from DOM.
				removeToastTimeout = setTimeout(() => {
					removeToast();
				}, 400);
			}, fadeOutTime);
		}
	};

	/**
	 * On click of the close button, remove immediately.
	 */
	const handleClick = (e) => {
		e.preventDefault();

		// Make sure we clear timeouts before
		if (removeToastFadeout) {
			clearTimeout(removeToastFadeout);
			clearTimeout(removeToastTimeout);
		}

		// Start fade out animation.
		setHide(true);

		// Tell the parent component to remove from the DOM.
		setTimeout(() => {
			removeToast();
		}, 400);
	};

	return (
		<div className={`flash-alert-message ${style.component} ${type && style[type]} ${hide && style.hide}`}>
			{text}
			<button onClick={handleClick}>
				<svg
					width="20"
					height="20"
					version="1.2"
					xmlns="http://www.w3.org/2000/svg"
					overflow="visible"
					preserveAspectRatio="none"
					viewBox="0 0 24 24"
				>
					<g>
						<path
							id="times"
							d="M18.18,15.77c0-0.27-0.1-0.52-0.29-0.71l-3.06-3.06l3.06-3.06c0.39-0.39,0.39-1.02,0.01-1.41c0,0,0,0-0.01-0.01  l-1.41-1.41c-0.39-0.39-1.02-0.39-1.41-0.01c0,0,0,0-0.01,0.01L12,9.16L8.94,6.11C8.55,5.71,7.92,5.71,7.52,6.1c0,0,0,0-0.01,0.01  L6.11,7.52C5.72,7.9,5.71,8.54,6.1,8.93c0,0,0,0,0.01,0.01l3.06,3.06l-3.06,3.06c-0.39,0.39-0.39,1.02-0.01,1.41c0,0,0,0,0.01,0.01  l1.42,1.42c0.39,0.39,1.02,0.39,1.41,0.01c0,0,0,0,0.01-0.01L12,14.82l3.06,3.06c0.39,0.39,1.02,0.39,1.41,0.01c0,0,0,0,0.01-0.01  l1.42-1.42c0.19-0.19,0.29-0.44,0.29-0.71l0,0L18.18,15.77z"
							vectorEffect="non-scaling-stroke"
						/>
					</g>
				</svg>
			</button>
		</div>
	);
}
